/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type ReputationRatingSubmittedEvent = {
  agent: Address;
  client: Address;
  rating: number;
  newReputationScore: bigint;
  timestamp: bigint;
};

export type ReputationRatingSubmittedEventArgs = {
  agent: Address;
  client: Address;
  rating: number;
  newReputationScore: number | bigint;
  timestamp: number | bigint;
};

export function getReputationRatingSubmittedEventEncoder(): FixedSizeEncoder<ReputationRatingSubmittedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["client", getAddressEncoder()],
    ["rating", getU8Encoder()],
    ["newReputationScore", getU64Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getReputationRatingSubmittedEventDecoder(): FixedSizeDecoder<ReputationRatingSubmittedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["client", getAddressDecoder()],
    ["rating", getU8Decoder()],
    ["newReputationScore", getU64Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getReputationRatingSubmittedEventCodec(): FixedSizeCodec<
  ReputationRatingSubmittedEventArgs,
  ReputationRatingSubmittedEvent
> {
  return combineCodec(
    getReputationRatingSubmittedEventEncoder(),
    getReputationRatingSubmittedEventDecoder(),
  );
}
